// extracted by mini-css-extract-plugin
export var adjacentSlide = "_lt-9";
export var arrowButtonContainer = "_lt-5";
export var arrowButtonIcon = "_lt-6";
export var carouselArrowButton = "_lt-2";
export var carouselElementContainer = "_lt-1";
export var currentSlide = "_lt-8";
export var left = "_lt-3";
export var otherSlide = "_lt-a";
export var productCarouselContainer = "_lt-0";
export var right = "_lt-4";
export var sliderOverflow = "_lt-7";